import React from 'react'
import { IconStar } from '../..'
import { IconLightning } from '../../icons'
import { IconPin } from '../../icons/IconPin/IconPin'
import { ChipVariant } from '../Chip/Chip'
import { StyledChipIcon } from '../Chip/Chip.styled'
const aquatics = require('../Chip/assets/CommonwealthGames/aquatics.svg')
const athletics = require('../Chip/assets/CommonwealthGames/athletics.svg')
const badminton = require('../Chip/assets/CommonwealthGames/badminton.svg')
const basketball = require('../Chip/assets/CommonwealthGames/basketball.svg')
const cricket = require('../Chip/assets/CommonwealthGames/cricket.svg')
const cycling = require('../Chip/assets/CommonwealthGames/cycling.svg')
const gymnastics = require('../Chip/assets/CommonwealthGames/gymnastics.svg')
const hockey = require('../Chip/assets/CommonwealthGames/hockey.svg')
const judo = require('../Chip/assets/CommonwealthGames/judo.svg')
const rugby = require('../Chip/assets/CommonwealthGames/rugby.svg')
const swimming = require('../Chip/assets/CommonwealthGames/swimming.svg')
const tabletennis = require('../Chip/assets/CommonwealthGames/tabletennis.svg')
const volleyball = require('../Chip/assets/CommonwealthGames/volleyball.svg')
const weightlifting = require('../Chip/assets/CommonwealthGames/weightlifting.svg')
const wrestling = require('../Chip/assets/CommonwealthGames/wrestling.svg')
const ceremony = require('../Chip/assets/CommonwealthGames/ceremony.svg')
const medalMoment = require('../Chip/assets/CommonwealthGames/medal-moment.svg')
const aussieMoment = require('../Chip/assets/CommonwealthGames/aussie-moment.svg')
const medal = require('../Chip/assets/CommonwealthGames/medal.svg')
const worldRecord = require('../Chip/assets/CommonwealthGames/world-record.svg')
const q = require('../Chip/assets/AFL/q.svg')
const goal = require('../Chip/assets/AFL/goal.svg')
const ball = require('../Chip/assets/AFL/ball.svg')
const behind = require('../Chip/assets/AFL/behind.svg')
const bigCall = require('../Chip/assets/AFL/bigCall.svg')
const brutalHit = require('../Chip/assets/AFL/brutalHit.svg')
const injury = require('../Chip/assets/AFL/injury.svg')
const newsUpdate = require('../Chip/assets/AFL/newsUpdate.svg')
const ouch = require('../Chip/assets/AFL/ouch.svg')
const premiers = require('../Chip/assets/AFL/premiers.svg')
const scoreUpdate = require('../Chip/assets/AFL/scoreUpdate.svg')
const topMoments = require('../Chip/assets/AFL/topMoments.svg')
const compensation = require('../Chip/assets/AFL/compensation.svg')
const confirmed = require('../Chip/assets/AFL/confirmed.svg')
const delisted = require('../Chip/assets/AFL/delisted.svg')
const doneDeal = require('../Chip/assets/AFL/doneDeal.svg')
const pickSwap = require('../Chip/assets/AFL/pickSwap.svg')
const tradeAlert = require('../Chip/assets/AFL/TA.svg')
const prediction = require('../Chip/assets/AFL/prediction.svg')
const reaction = require('../Chip/assets/AFL/reaction.svg')
const rumour = require('../Chip/assets/AFL/rumour.svg')
const statement = require('../Chip/assets/AFL/statement.svg')
const whispers = require('../Chip/assets/AFL/whispers.svg')

const tryIcon = require('../Chip/assets/NRL/try.svg')
const penalty = require('../Chip/assets/NRL/penalty.svg')
const bigHit = require('../Chip/assets/NRL/bigHit.svg')
const captainsChallenge = require('../Chip/assets/NRL/captainsChallenge.svg')
const conversionSuccesful = require('../Chip/assets/NRL/conversionSuccesful.svg')
const conversionUnsuccesful = require('../Chip/assets/NRL/conversionUnsuccesful.svg')
const error = require('../Chip/assets/NRL/error.svg')
const interchange = require('../Chip/assets/NRL/interchange.svg')
const kickoff = require('../Chip/assets/NRL/kickoff.svg')
const lineBreak = require('../Chip/assets/NRL/lineBreak.svg')
const lineDropout = require('../Chip/assets/NRL/lineDropout.svg')
const noTry = require('../Chip/assets/NRL/noTry.svg')

// soccer
const kickoffSoccer = require('../Chip/assets/soccer/kickoff.svg')
const time = require('../Chip/assets/soccer/time.svg')
const penaltyShootout = require('../Chip/assets/soccer/penaltyShootout.svg')
const offside = require('../Chip/assets/soccer/offside.svg')
const freeKick = require('../Chip/assets/soccer/freeKick.svg')
const penaltySoccer = require('../Chip/assets/soccer/penalty.svg')
const worldieAlert = require('../Chip/assets/soccer/worldieAlert.svg')
const card = require('../Chip/assets/soccer/card.svg')
const substitution = require('../Chip/assets/soccer/substitution.svg')
const tackle = require('../Chip/assets/soccer/tackle.svg')
const block = require('../Chip/assets/soccer/block.svg')
const shot = require('../Chip/assets/soccer/shot.svg')
const worldCupWinners = require('../Chip/assets/soccer/worldCupWinners.svg')
const socceroos = require('../Chip/assets/soccer/socceroos.svg')

export function getChipIcon(variant: ChipVariant, text?: string) {
    switch (variant) {
        case 'pinned':
            return <IconPin />
        case 'happening':
            switch (text) {
                // commonwealth games
                case 'Wrestling':
                    return <StyledChipIcon src={wrestling} />
                case 'Aquatics':
                    return <StyledChipIcon src={aquatics} />
                case 'Athletics':
                    return <StyledChipIcon src={athletics} />
                case 'Badminton':
                    return <StyledChipIcon src={badminton} />
                case 'Basketball':
                    return <StyledChipIcon src={basketball} />
                case 'Cricket':
                    return <StyledChipIcon src={cricket} />
                case 'Cycling':
                    return <StyledChipIcon src={cycling} />
                case 'Gymnastics':
                    return <StyledChipIcon src={gymnastics} />
                case 'Hockey':
                    return <StyledChipIcon src={hockey} />
                case 'Judo':
                    return <StyledChipIcon src={judo} />
                case 'Rugby':
                    return <StyledChipIcon src={rugby} />
                case 'Swimming':
                    return <StyledChipIcon src={swimming} />
                case 'Table Tennis':
                    return <StyledChipIcon src={tabletennis} />
                case 'Beach Volleyball':
                    return <StyledChipIcon src={volleyball} />
                case 'Weightlifting':
                    return <StyledChipIcon src={weightlifting} />
                case 'Opening Ceremony':
                case 'Closing Ceremony':
                    return <StyledChipIcon src={ceremony} />
                case 'Gold Medal':
                case 'Silver Medal':
                case 'Bronze Medal':
                    return <StyledChipIcon src={medal} />
                case 'World Record':
                    return <StyledChipIcon src={worldRecord} />
                case 'Aussie Moment':
                    return <StyledChipIcon src={aussieMoment} />
                case 'Medal Moment':
                    return <StyledChipIcon src={medalMoment} />
                // AFL
                case 'Q1':
                case 'Q2':
                case 'Q3':
                case 'Q4':
                case 'Half-time':
                case 'Full-time':
                case 'Quarter-time':
                    return <StyledChipIcon src={q} />
                case 'Goal':
                    return <StyledChipIcon src={goal} />
                case 'Baaaallll!':
                    return <StyledChipIcon src={ball} />
                case 'Behind':
                    return <StyledChipIcon src={behind} />
                case 'Big Call':
                    return <StyledChipIcon src={bigCall} />
                case 'Brutal Hit':
                    return <StyledChipIcon src={brutalHit} />
                case 'Injury':
                    return <StyledChipIcon src={injury} />
                case 'News Update':
                    return <StyledChipIcon src={newsUpdate} />
                case 'Ouch':
                    return <StyledChipIcon src={ouch} />
                case 'Premiers':
                    return <StyledChipIcon src={premiers} />
                case 'Score Update':
                    return <StyledChipIcon src={scoreUpdate} />
                case 'Top Moments':
                    return <StyledChipIcon src={topMoments} />
                case 'Rumour':
                    return <StyledChipIcon src={rumour} />
                case 'Confirmed':
                    return <StyledChipIcon src={confirmed} />
                case 'Reaction':
                    return <StyledChipIcon src={reaction} />
                case 'Statement':
                    return <StyledChipIcon src={statement} />
                case 'Done deal':
                    return <StyledChipIcon src={doneDeal} />
                case 'Pick swap':
                    return <StyledChipIcon src={pickSwap} />
                case 'Trade alert':
                    return <StyledChipIcon src={tradeAlert} />
                // Missing icon for trade alert
                case 'Whispers':
                    return <StyledChipIcon src={whispers} />
                case 'Prediction':
                    return <StyledChipIcon src={prediction} />
                case 'Delisted':
                    return <StyledChipIcon src={delisted} />
                case 'Compensation':
                    return <StyledChipIcon src={compensation} />

                // NRL
                case 'Try':
                    return <StyledChipIcon src={tryIcon} />
                case 'No try':
                    return <StyledChipIcon src={noTry} />
                case 'Penalty':
                case 'Video Referee':
                    return <StyledChipIcon src={penalty} />
                case 'Conversion Successful':
                    return <StyledChipIcon src={conversionSuccesful} />
                case 'Conversion Unsuccessful':
                    return <StyledChipIcon src={conversionUnsuccesful} />
                case 'Kickoff':
                case 'Kick-off':
                    return <StyledChipIcon src={kickoff} />
                case 'Interchange':
                    return <StyledChipIcon src={interchange} />
                case 'Big Hit':
                    return <StyledChipIcon src={bigHit} />
                case 'Error':
                    return <StyledChipIcon src={error} />
                case 'Line Break':
                    return <StyledChipIcon src={lineBreak} />
                case "Captain's Challenge":
                    return <StyledChipIcon src={captainsChallenge} />
                case 'Line Dropout':
                    return <StyledChipIcon src={lineDropout} />
                // Soccer
                case 'Group Stage':
                case 'Round of 16':
                case 'Third Place Playoff':
                case 'Quarterfinal':
                case 'Semifinal':
                case 'Final':
                    return <StyledChipIcon src={kickoffSoccer} />
                case 'Extra Time':
                case 'Half Time':
                case 'Full Time':
                case 'First Half':
                case 'Second Half':
                case 'Quarter Time':
                    return <StyledChipIcon src={time} />
                case 'Penalty Shootout':
                    return <StyledChipIcon src={penaltyShootout} />
                case 'Offside':
                    return <StyledChipIcon src={offside} />
                case 'Free Kick':
                    return <StyledChipIcon src={freeKick} />
                case 'Worldie Alert':
                    return <StyledChipIcon src={worldieAlert} />
                case 'Yellow Card':
                case 'Red Card':
                    return <StyledChipIcon src={card} />
                case 'Substitution':
                    return <StyledChipIcon src={substitution} />
                case 'Tackle':
                    return <StyledChipIcon src={tackle} />
                case 'Shot':
                    return <StyledChipIcon src={shot} />
                case 'Block/Save':
                    return <StyledChipIcon src={block} />
                case 'World Cup Winners':
                    return <StyledChipIcon src={worldCupWinners} />
                case 'Socceroos':
                    return <StyledChipIcon src={socceroos} />

                default:
                    return <IconLightning />
            }
        case 'label':
            return <IconStar />
        default:
            return
    }
}
